<template>
  <div class="photography-intro-content" id="identidade-visual-fotografia-introducao" data-search-anchor>
    <h1 class="photography-intro-title">{{ photographyIntroTitle }}</h1>
    <div class="description-content-photo">
      <p class="photography-intro-description-paragraph">
        {{ photographyIntroDescriptionParagraph1 }}
      </p>
      <p class="photography-intro-description-paragraph">
        {{ photographyIntroDescriptionParagraph2 }}
      </p>
      <p class="photography-intro-description-paragraph" style="margin-bottom: 0;">
        {{ photographyIntroDescriptionParagraph3 }}
      </p>
      <div class="button-photography-intro-wrapper">
      <RedirectOneDriveButton
          :linkUrl="onedriveUrl"
          buttonText="Baixar fotos"
      />        
    </div>      
    </div>    
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import PhotographyPageMixin from '@/mixins/photography-page-mixin'
import { PhotographyPageStore } from '@/store/visual-identity-page/photography-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class PhotographyIntroSection extends Mixins(PhotographyPageMixin) {
  photographyPageStore: PageStoreContract = getModule(PhotographyPageStore, this.$store)

  onedriveUrl = 'https://tvglobocorp.sharepoint.com/sites/intranetconexao/DocumentosMarca/Fotografia'

  get photographyIntroTitle(): string {
    return this.getElementText(1, 0)
  }

  get photographyIntroDescriptionParagraph1(): string {
    return this.getElementText(1, 1)
  }

  get photographyIntroDescriptionParagraph2(): string {
    return this.getElementText(1, 2)
  }

  get photographyIntroDescriptionParagraph3(): string {
    return this.getElementText(1, 3)
  } 

  async getPhotographyPage(): Promise<void> {
    await this.photographyPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.photographyPageStore.isLoading) {
      await this.getPhotographyPage()
    }
  }
}
</script>

<style lang="scss">
.photography-intro-content { 
  display: grid;
  grid-template-columns: 50% 50%;  
  width: 100%;
  max-width: 1032px;
}

.photography-intro-title {  
  font-size: 65px;
  font-weight: 400;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin: 0; 
  white-space: pre-line;
}

.description-content-photo {
  max-width: 488px;
  width: 100%;  
}

.photography-intro-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.photography-intro-description-paragraph {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.button-photography-intro-wrapper {
  display: flex;
  align-items: center;  
  padding-top: 2rem;
}
</style>
